import { render, staticRenderFns } from "./Teams.vue?vue&type=template&id=4fa81422&scoped=true"
import script from "./Teams.vue?vue&type=script&lang=js"
export * from "./Teams.vue?vue&type=script&lang=js"
import style0 from "./Teams.vue?vue&type=style&index=0&id=4fa81422&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa81422",
  null
  
)

export default component.exports